import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import styles from './datalist.module.css';

const unique = () => Math.random().toString(16);
const Datalist = forwardRef(({ className, onChange, name, id, placeholder, error, value, options = [], optionsValue, fullWidth, ...props }, ref) => {
    const UniqueId = unique();
    return (
        <>
            <input ref={ref} 
                list={UniqueId}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={`${className} ${styles.Datalist} ${(error ? "errorInput" : "")} ${(fullWidth ? styles.fullWidth : "")}`}
                id={id || name}
                name={name}
                {...props}
            />
            <datalist ref={ref}
                id={UniqueId}
                name={UniqueId}
                
            >
                
                {options.map((o, i) => (
                    <option key={i} value={optionsValue ? optionsValue(o) : o} />
                ))}
            </datalist>
            {error && (
                <small className="errorInput">{error}</small>
            )}
        </>
    )
})
Datalist.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func,
    name: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    value: PropTypes.string,
    options: PropTypes.array,
    optionsValue: PropTypes.func,
    fullWidth: PropTypes.bool
}

export default Datalist;